<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-dialog
        v-model="dialog"
        persistent
        max-width="500px"
        transition="dialog-transition"
      >
        <v-card>
          <v-card-title primary-title>
            <span v-if="!editMode">Přidat položku</span><span v-else>Upravit položku {{ dItem.name }}</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              label="Název položky"
              v-model="dName"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="!editMode" color="green" flat @click="add" :loading="sending">Vyvořit položku</v-btn>
            <v-btn v-else color="green" flat @click="edit" :loading="sending">Upravit položku</v-btn>
            <v-btn color="grey" flat @click="dialog=false;" v-if="!sending">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogRemove"
        persistent
        max-width="500px"
        transition="dialog-transition"
        v-if="dItem != null"
      >
        <v-card>
          <v-card-title primary-title>
            Smazat položku {{ dItem.name }}
          </v-card-title>
          <v-card-text>
            <p class="text-center subheading">Opravdu chcete smazat položku <strong>{{ dItem.name }}</strong>?</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" flat @click="remove" :loading="sending">Smazat položku</v-btn>
            <v-btn color="grey" flat @click="dialogRemove=false;" v-if="!sending">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-toolbar color="transparent" class="elevation-0 p0">
        <v-toolbar-title>Číselník {{ name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="blue accent-3" flat class="ml0" @click="addClick"><v-icon class="mr5">add</v-icon> Přidat položku</v-btn>
      </v-toolbar>
      <div class="pl-4 pr-4">
        <v-data-table
          :headers="table_headers"
          :items="items"
          hide-controls
          class="elevation-0 mt-0"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td class="subheading">{{props.item.name}}</td>
              <td class="text-xs-right">
                <v-tooltip bottom>
                  <v-btn slot="activator" color="blue" flat fab class="ma-0 mt-5 mb-5 mr-2" @click="editClick(props.item)" small><v-icon small>edit</v-icon></v-btn>
                  <span>Upravit položku</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn slot="activator" color="blue" flat fab class="ma-0 mt-5 mb-5" :disabled="props.index==0" @click="moveUp(props.index)" small><v-icon small>arrow_upward</v-icon></v-btn>
                  <span>Posunout nahoru</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn slot="activator" color="blue" flat fab class="ma-0 mt-5 mb-5 mr-2" :disabled="props.index==items.length-1" @click="moveDown(props.index)" small><v-icon small>arrow_downward</v-icon></v-btn>
                  <span>Posunout dolů</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn slot="activator" color="red darken-2" flat fab class="ma-0 mt-5 mb-5" @click="removeClick(props.item)" small><v-icon small>delete_forever</v-icon></v-btn>
                  <span>Smazat položku</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>

export default {
  data () {
    return {
      table_headers: [
        { text: "Název", value: "name", sortable: false },
        { text: "", value: null, sortable: false }
      ],
      table_items: [],
      dialog: false,
      dialogRemove: false,
      dName: "",
      dItem: {},
      editMode: false,
      sending: false
    }
  },
  props: {
    name: String,
    items: Array,
    enum: String
  },
  mounted: function() {
    //this.table_items = this.$props.items;
    console.log("mounted");
  },
  methods: {
    addClick: function() {
      this.dName = "";
      this.dItem = null;
      this.editMode = false;
      this.dialog = true;
    },
    add: function() {
      this.sending = true;
      window.api.post("ciselniky/"+this.$props.enum, {
        nazev: this.dName
      }).then(function($r) {
        this.items.push($r.data);
        this.sending = false;
        this.dialog = false;
      }.bind(this)).catch(function($err) {
        console.log($err);
      }.bind(this));
    },
    editClick: function(item) {
      this.dName = item.name;
      this.dItem = item;
      this.editMode = true;
      this.dialog = true;
    },
    edit: function() {
      this.sending = true;
      window.api.put("ciselniky/"+this.$props.enum+"/"+this.dItem.id.toString(), {
        nazev: this.dName
      }).then(function($r) {
        this.dItem.name = this.dName;
        this.sending = false;
        this.dialog = false;
      }.bind(this)).catch(function($err) {
        console.log($err);
      }.bind(this));
    },
    removeClick: function(item) {
      this.dItem = item;
      this.dialogRemove = true;
    },
    remove: function() {
      this.sending = true;
      window.api.delete("ciselniky/"+this.$props.enum+"/"+this.dItem.id.toString()).then(function($r) {
        this.items.splice(this.items.indexOf(this.dItem), 1);
        this.sending = false;
        this.dialogRemove = false;
      }.bind(this)).catch(function($err) {
        console.log($err);
      }.bind(this));

    },
    moveUp: function(index) {
      var id = this.items[index];
      this.items.splice(index, 1);
      this.items.splice(index-1, 0, id);
      window.api.put("ciselniky/"+this.$props.enum+"/poradi", {
        polozky: this.items.map(function($e) {
          return $e.id;
        })
      }).then(function($r) {

      }.bind(this)).catch(function($err) {
        console.log($err);
      }.bind(this));
    },
    moveDown: function(index) {
      var id = this.items[index];
      this.items.splice(index, 1);
      this.items.splice(index+1, 0, id);
      window.api.put("ciselniky/"+this.$props.enum+"/poradi", {
        polozky: this.items.map(function($e) {
          return $e.id;
        })
      }).then(function($r) {

      }.bind(this)).catch(function($err) {
        console.log($err);
      }.bind(this));
    }
  },
  components: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Nastaveni/CiselnikyPages/CiselnikBasic.vue